import { IconClose } from '@adserve/adserve-react-components';
import React, { useState } from 'react';
import EntityMatcherItem from './EntityMatcherItem';

const EntityMatcherTongue = ({
    values,
    selectedValue,
    onSelect,
    onClose
}) => {
    const [highlightedRow, setHighlightedRow] = useState(-1);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                position: 'absolute',
                border: '1px solid #CCCCCC',
                borderRadius: '0 0 15px 15px',
                backgroundColor: '#FFFFFF',
                width: '100%',
                boxSizing: 'border-box',
                paddingTop: 10,
                paddingBottom: 10,
                marginTop: -3
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    paddingLeft: 10,
                    paddingRight: 10
                }}
            >
                <IconClose
                    id='scriptFactorsClose'
                    size={15}
                    onClick={onClose}
                />
            </div>

            {values.map((value, i) => (
                <EntityMatcherItem
                    key={`value${i}`}
                    rowIndex={i}
                    onHover={setHighlightedRow}
                    onSelect={onSelect}
                    value={value}
                    selectedValue={selectedValue}
                    isHighlighted={highlightedRow === i}
                />
            ))}
        </div>
    );
};

export default EntityMatcherTongue;
